(function() {
  const GIFT_VARIANT_ID = 48493688586490;
  const GIFT_PRODUCT_ID = 9145241927930;
  
  function initGiftWrap() {
    const cartForm = document.querySelector('form[action="/cart"]');
    if (!cartForm) return;
    
    // Crear el checkbox con nuevo estilo
    const checkboxHTML = `
      <div class="gift-wrap-option" style="
        margin: 20px 0;
        padding: 16px 20px;
        background: #FFFFFF;
        border: 2px solid #ADD7D69E;
        padding: 16px 28px;
        border-radius: 22px;
        display: flex;
        align-items: center;
        gap: 12px;
        font-family: inherit;
      ">
        <input 
          type="checkbox" 
          id="gift-wrap-checkbox" 
          style="
            width: 20px;
            height: 20px;
            accent-color: #f0a500;
            cursor: pointer;
            flex-shrink: 0;
          "
        >
        <label for="gift-wrap-checkbox" style="
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
          font-size: 15px;
          font-weight: 500;
          color: #333;
          margin: 0;
        ">
          <span style="font-size: 16px;">🎁</span>
          <span>Bolsa de Regalo $500</span>
        </label>
      </div>
    `;
    
    const checkoutButton = document.querySelector('[name="checkout"]') || 
                           document.querySelector('.cart__checkout-button') ||
                           document.querySelector('button[type="submit"]');
    
    if (checkoutButton) {
      checkoutButton.insertAdjacentHTML('beforebegin', checkboxHTML);
    } else {
      cartForm.insertAdjacentHTML('beforeend', checkboxHTML);
    }
    
    const checkbox = document.getElementById('gift-wrap-checkbox');
    if (!checkbox) return;
    
    // Verificar estado inicial
    checkCartForGiftWrap(checkbox);
    
    // Cambio manual del checkbox
    checkbox.addEventListener('change', function() {
      if (this.checked) {
        addGiftWrapToCart();
      } else {
        removeGiftWrapFromCart();
      }
    });

    // Detectar si el cliente elimina manualmente el producto del carrito
    startCartPolling(checkbox);
  }
  
  function checkCartForGiftWrap(checkbox) {
    return fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const hasGiftWrap = cart.items.some(item => 
          item.product_id === GIFT_PRODUCT_ID || 
          item.variant_id === GIFT_VARIANT_ID
        );
        checkbox.checked = hasGiftWrap;
        return hasGiftWrap;
      })
      .catch(error => console.error('Error checking cart:', error));
  }
  
  function addGiftWrapToCart() {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1 }]
      })
    })
    .then(response => response.json())
    .then(() => window.location.reload())
    .catch(error => {
      console.error('Error adding gift wrap:', error);
      alert('No se pudo agregar el embalaje de regalo. Por favor, intenta de nuevo.');
    });
  }
  
  function removeGiftWrapFromCart() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const giftItem = cart.items.find(item => 
          item.product_id === GIFT_PRODUCT_ID || 
          item.variant_id === GIFT_VARIANT_ID
        );
        if (giftItem) {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: giftItem.key, quantity: 0 })
          });
        }
      })
      .then(response => { if (response) window.location.reload(); })
      .catch(error => console.error('Error removing gift wrap:', error));
  }

  // Polling: verifica cada 2 segundos si el producto fue eliminado manualmente
  function startCartPolling(checkbox) {
    setInterval(function() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const hasGiftWrap = cart.items.some(item => 
            item.product_id === GIFT_PRODUCT_ID || 
            item.variant_id === GIFT_VARIANT_ID
          );
          // Si el checkbox está marcado pero el producto ya no está → desmarcar
          if (checkbox.checked && !hasGiftWrap) {
            checkbox.checked = false;
          }
          // Si el checkbox está desmarcado pero el producto está → marcar
          if (!checkbox.checked && hasGiftWrap) {
            checkbox.checked = true;
          }
        })
        .catch(error => console.error('Error polling cart:', error));
    }, 2000);
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGiftWrap);
  } else {
    initGiftWrap();
  }
})();

